import React from "react";
import { Plan } from "./Plans";
import fullMarks from "../../assets/Images/VerticalDarkLogo1.svg";
import { BiCheckCircle } from "react-icons/bi";

type PlanDetailsProps = {
  plan: Plan | null  | undefined;
};

const PlanDetailsCard = ({ plan }: PlanDetailsProps) => {
  return (
    <>
      {plan && (
        <div className="w-full flex flex-col font-gully gap-3 items-start self-stretch">
          <div className="w-full flex  items-center gap-3 ">
            <img src={plan?.planLogo.trim() !== '' ? plan?.planLogo : fullMarks} alt="sat-logo" className="w-14 h-14 rounded-md" style={{boxShadow : ' 0px 4px 8px 0px rgba(28, 37, 44, 0.08)'}}/>
            <div className="text-satPrepBlack w-full flex justify-between">
              <p className="text-xl font-medium">{plan?.planName}</p>
              <p className="text-lg">{plan?.currencySymbol}{plan?.price}</p>
            </div>
          </div>

          <div className="flex flex-col gap-[6px]">
            {
               plan?.packageDetails?.features.filter((feature) => feature?.isOffered).map((feature) => (
                  <div key={feature?.name} className='flex items-center gap-3'>
                      <BiCheckCircle size={24} className='mb-[2px] text-satPrepAccent'/>
                      <p className={`text-base text-satPrepBlack`}>{feature?.name}</p>
                  </div>
              ))
            }
          </div>
        </div>
      )}
    </>
  );
};

export default PlanDetailsCard;
